import { useTranslation } from "@msuite/ui/localization";
import { ConfirmModal, useAsyncModal } from "@msuite/ui/modal";
import { useDataTableContext } from "@msuite/ui/table";
import { toast } from "@msuite/ui/toast";
import { Fragment } from "@msuite/ui/utils";

export function useDeleteItem(fn: () => Promise<void>) {
	/** Hooks */
	const asyncModal = useAsyncModal();
	const { t } = useTranslation();
	const context = useDataTableContext();

	function RenderOnDeleteModal() {
		return (
			<Fragment>
				{asyncModal.isOpen && (
					<ConfirmModal
						controller={asyncModal}
						message={t("confirmation.confirm_deletion")}
					/>
				)}
			</Fragment>
		);
	}

	async function handleOnDelete() {
		const isConfirmed = await asyncModal.confirm();
		if (!isConfirmed) return;
		toast.promise(
			async () => {
				await fn?.();
				await context?.refetch?.();
			},
			{
				loading: t("general.deleting"),
				success: t("general.successfully_deleted"),
				error: t("general.deleting_failed"),
			},
		);
	}

	return {
		RenderOnDeleteModal,
		handleOnDelete,
	};
}
